import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Common/Icon';
import { PLATFORM_GUIDANCE } from '../../../content/helpGuidanceContent';

const LandingPrivacySection = React.memo(({ onGetDesktopApp }) => (
  <section id="privacy" className="landing-privacy-section">
    <div className="landing-template-frame landing-privacy-frame">
      <div className="landing-privacy-copy">
        <h2>Private by design. Yours, always.</h2>
        <p>Choose the platform that fits how you work. Each one keeps your records and controls explicit.</p>
        <div className="landing-editorial-rule" aria-hidden="true">
          <Icon name="sprout" size={23} />
          <span />
        </div>
      </div>

      <button type="button" className="landing-privacy-device" onClick={onGetDesktopApp}>
        <img
          src="/landing/desktop-workspace.jpg"
          alt="ThryveLoop desktop app shown on a monitor"
          loading="lazy"
        />
      </button>

      <div className="landing-privacy-list">
        {PLATFORM_GUIDANCE.map((platform) => (
          <article key={platform.id} className="landing-privacy-point">
            <span>
              <Icon name={platform.icon} size={18} />
            </span>
            <div>
              <small>{platform.eyebrow}</small>
              <h3>{platform.title}</h3>
              <p>{platform.summary}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
));

LandingPrivacySection.propTypes = {
  onGetDesktopApp: PropTypes.func.isRequired,
};

LandingPrivacySection.displayName = 'LandingPrivacySection';

export default LandingPrivacySection;
